import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Role, Team } from '@/hooks/api/models';
import { useEffect, useState } from 'react';

/**
 * 0290. チームメンバー権限一覧
 * [GET] /roles
 */
const roles = (): Promise<Role[]> => {
  return axios.get(`/api/roles`);
};

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => roles(),
  });
};

export const useRolesObject = () => {
  const { data } = useRoles();
  const [adminRole, setAdminRole] = useState<Role>();
  const [approverRole, setApproverRole] = useState<Role>();
  const [financialOfficerRole, setFinancialOfficerRole] = useState<Role>();
  const [backofficeRole, setBackofficeRole] = useState<Role>();
  const [memberRole, setMemberRole] = useState<Role>();

  useEffect(() => {
    if (data) {
      setAdminRole(data.find((r) => r.name == 'admin'));
      setApproverRole(data.find((r) => r.name == 'approver'));
      setFinancialOfficerRole(data.find((r) => r.name == 'financial_officer'));
      setBackofficeRole(data.find((r) => r.name == 'backoffice'));
      setMemberRole(data.find((r) => r.name == 'member'));
    }
  }, [data]);

  return { adminRole, approverRole, financialOfficerRole, backofficeRole, memberRole };
};
